export type AuthRoleParam = "leader" | "coach" | null;
export type AuthMode = "login" | "signup" | "forgot";
export type AuthSignupAccountMode = "solo_trial";

export function resolveAuthRouteRole(pathname: string): AuthRoleParam {
  if (pathname === "/leader/signup" || pathname === "/leader/sign-up") return "leader";
  if (pathname === "/coach/signup" || pathname === "/coach/sign-up") return "coach";
  return null;
}

export function resolveAuthInitialMode(roleParam: AuthRoleParam, modeParam: string | null): AuthMode {
  if (modeParam === "login") return "login";
  if (modeParam === "signup") return "signup";
  if (roleParam === "leader" || roleParam === "coach") return "signup";
  return "signup";
}

export function resolveAuthSignupRole(roleParam: AuthRoleParam): "coach" | "leader" {
  return roleParam === "leader" ? "leader" : "coach";
}

export function resolveAuthSignupDestination(roleParam: AuthRoleParam): string {
  return resolveAuthSignupRole(roleParam) === "leader" ? "/today" : "/coach/overview";
}

export function resolveAuthSignupTrialIntent(roleParam: AuthRoleParam): { accountMode: AuthSignupAccountMode | null } {
  return {
    accountMode: roleParam === "leader" ? "solo_trial" : null,
  };
}

export function resolveSignupCtaLabel(roleParam: AuthRoleParam, isLoading: boolean): string {
  if (isLoading) return "Creating account...";
  return resolveAuthSignupRole(roleParam) === "leader" ? "Create Leader Account" : "Create Coach Account";
}
